var map = {
	"./CH-VD.geojson": 511,
	"./FR-01.geojson": 512,
	"./FR-25.geojson": 513,
	"./FR-39.geojson": 514,
	"./FR-67.geojson": 515,
	"./FR-68.geojson": 516,
	"./FR-70.geojson": 517,
	"./FR-73.geojson": 518,
	"./FR-74.geojson": 519,
	"./FR-88.geojson": 520,
	"./FR-90.geojson": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;